<template>
    <div>
        <div class="modal fade" id="mdlconsultaprodutosnotafor" tabindex="-1" role="dialog">
			<div class="modal-dialog full_modal-dialog " role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title"><i class="fa fa-search"></i> Consulta notas de fornecedores</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">                        
					<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
                    <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div>                            
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="ednumeropesq">Número:</label>
                                <input id="ednumeropesq" type="text" class="form-control form-control-sm" v-model="pnumero" @keyup="mtdlimpar_listagem()" v-mask="'###########'">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>                              
                            <div class="col-12 col-sm-2 col-md-1 col-lg-1 col-xl-1">
                                <label for="cbtiponotapesq">Tipo:</label>
                                <select class="form-control form-control-sm" id="cbtiponotapesq" v-model="ptipo" @change="mtdlimpar_listagem()">
                                    <option value="0">Nota Fiscal</option>
                                    <option value="1">Pedido</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                                                     
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="cbfiltroperiodo">Período:</label>
                                <select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpdata">Data de:</label>
                                <select class="form-control form-control-sm" id="cbtpdata" v-model="ptpdata" v-bind:disabled="hab_desab_periodo"  @change="mtdlimpar_listagem()">
                                    <option value="0">Emissão</option>
                                    <option value="1">Efetivação</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>								
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtfim">até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>																			
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cblistar">Situação:</label>
                                <select class="form-control form-control-sm" id="cblistar" v-model="pstnota" @change="mtdlimpar_listagem()">
                                    <option value="0">Em digitação</option>
                                    <option value="1">Efetivadas</option>
                                    <option value="2">Canceladas</option>
                                    <option value="3" selected="true">Todas</option>
                                </select>
                            </div>                                                                                    
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistrosnotasf" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>                                                        
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstnotas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>    
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdimportaprodutos(item.row.itens)" style="width: 35px;">
                                            <i class="fa fa-hand-pointer-o"></i>
                                        </button>                                        
                                    </template>
                                    <template slot="slot_detalhes" slot-scope="item">
                                        <i @click.prevent="mtddetalhesnota(item.row)" class="fa fa-info-circle icon-detalhes" title="Detalhes da Nota"></i>
                                    </template>                                    
                                    <template slot="slot_numero" slot-scope="item">
                                        {{ item.row.numero }}
                                    </template>                                    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4; float: left;">Em edição</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 2" class="badge badge-pill badge-danger" style="background: #f82b54; float: left;">Cancelada</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a; float: left;">Efetivada</span>
                                        <span v-if="parseInt(item.row.atualizada) === 1" style="color: #f82b54; float: left; margin-top: -4px; margin-left: 7px;" title="Atualização de valores já processada."><i class="fa fa-check-circle-o"></i></span>
                                    </template>
                                    <template slot="slot_conferida" slot-scope="item">
                                        <span v-if="parseInt(item.row.conferida) === 1" title="Conferência finalizada"><i class="fa fa-check-square-o" style="color: #5a956a; font-weight: 600; font-size: 18px;"></i></span>
                                        <span v-else-if="parseInt(item.row.confiniciada) === 1" title="Conferência iniciada"><i class="fa fa-qrcode" style="color: rgb(84 70 70); font-weight: 600; font-size: 18px;"></i></span>
                                        <span></span>
                                    </template>                                                                         
                                    <template slot="slot_vtotvtotal" slot-scope="item">
                                        <span class="text-black-50" style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vtotvtotal) - (parseFloat(item.row.vtotdesc)) + parseFloat(item.row.vtotvipi) + parseFloat(item.row.vst) + parseFloat(item.row.vtotvfrete) + parseFloat(item.row.vtotvoutros), 2) }}</span>
                                    </template> 
                                    <template slot="slot_dtefetivacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 1" >{{ item.row.dtefetivacao.substring(0, 10) }}</span>
                                        <span v-else></span>
                                    </template> 
                                    <template slot="slot_tipo" slot-scope="item">
                                        <span v-if="parseInt(item.row.tipo) === 0" class="badge badge-pill badge-primary">Nota fiscal</span>
                                        <span v-else class="badge badge-pill badge-secondary">Pedido</span>                                        
                                    </template>                                                                                                           
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        <span>Totalizadores <span class="badge badge-info badge-pill">{{lstnotas.length}}</span></span>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #5A956A;">{{mtdformatavalordecimal(parseFloat(totalnotas), 2)}}</span>
                                    </li>
                                </ul>                                
                            </div>
                        </div>
                        <div class="row">                            
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atualnotaf"
                                        :page-count="pqtd_paginasnotaf"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                        </div>
				</div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>
				</div>
			</div>
		</div>
        <!-- Modal para visualizar detalhes da Nota -->
        <div class="modal fade" id="mddetalhesnf" tabindex="-1" aria-labelledby="mdldetalhesnf" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhesnf"><i class="fa fa-info-circle"></i> Detalhes da Nota</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpfornecedordet">Fornecedor:</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" id="edpfornecedor" v-bind:value="detnota.idfornecedor+' - '+detnota.nomefornecedor"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpnnf">Número NF-e:</label>
                                <input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="edpnnf" v-model="detnota.numero"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpdhemi">Emissão:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpdhemi" v-model="detnota.dtemissao"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpmod">Modelo:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpmod" v-model="detnota.modelo"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label for="edpserie">Série:</label>
                                <input type="text" class="form-control form-control-sm text-right" id="edpserie" v-model="detnota.serie"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <label for="edpnatop">Natureza da operação:</label>
                                <input type="text" class="form-control form-control-sm text-uppercase" id="edpnatop" v-model="detnota.naturezaoperacao"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                <label for="edpchnfe">Chave de acesso:</label>
                                <input type="text" class="form-control form-control-sm text-center font-weight-bold text-secondary" id="edpchnfe" v-model="detnota.chaveacesso"
                                    data-bv-group=".group" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="edtotalnotadet">Total Nota:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edtotalnotadet" 
                                    v-model="detnota.vtotvtotal" v-bind="money"
                                    data-bv-group=".group" style="text-align:right;" disabled>
                                </money>                                
                            </div>
                            <!-- <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <button v-if="parseInt(detnota.conferida) === 0" type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtddefinirconferida(detnota)" ><i class="fa fa-check-square-o"></i> Conferida</button>
                                <button v-else type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtddefinirconferida(detnota)">À conferir</button>
                            </div>                             -->
						</div>
                        <div class="row">
                            <div class="col-lg-12">                                
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th width="30">Item:</th>
                                            <th width="100">Codigo:</th>
                                            <th width="300">Descrição:</th>
                                            <th width="100">Referência:</th>
                                            <th width="40">Und:</th>
                                            <th width="40">IPI(%):</th>
                                            <th width="100">Pr. Compra:</th>
                                            <th width="100">Pr. Custo:</th>
                                            <th width="50">Qtd:</th>                                            
                                            <th width="100">Vl. Descto:</th>
                                            <th width="100">Vl. Total:</th>
                                            <th width="50">Qtd falta:</th>   
                                            <th width="100">Local.:</th>
                                            <th width="100">Estoque:</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in detnota.itens" v-bind:key="index" style="font-size: 12px;">
                                                <td class="text-center">{{item.item}}</td>
                                                <td>{{item.coddig}}</td>
                                                <td>{{item.descricao}}</td>
                                                <td>{{item.referencia}}</td>
                                                <td>{{item.und}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vpipi), 2)}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.prcompra), 3)}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vprcusto), 3)}}</td>
                                                <td style="text-align: right;">{{item.qtditem}}</td>
                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vdesconto), 3)}}</td>
                                                <td style="text-align: right; font-weight: 500;">{{mtdformatavalordecimal(parseFloat(item.vvtotal), 3)}}</td>
                                                <td style="text-align: right;" title="Quantidade que falta. De acordo com o pedido de compra na qual a nota foi relacionada." >{{item.qtdfaltapedido}}</td>                                                    
                                                <td>{{item.localizacao}}</td>
                                                <td>{{item.descestoque}}</td>
                                            </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                            </div>
                        </div>
					</div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-primary btn-sm" style="width: 150px;" @click.prevent="mtdexportarexcel()"><i class="fa fa-upload"></i> Exportar itens</button> -->
                        <button type="button" class="btn btn-secondary btn-sm" style="width: 150px;" data-dismiss="modal"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>
    </div>
</template>
<script>
    import { computed } from 'vue';
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name:"cmpconsultaprodutosnotafor",
        props:[
        ],
        components:{
            VueBootstrap4Table,
            vPagination,

        },
        data: function(){
            return{
                pidfilial           : null,
                pnumero             : '',
                pidfornecedor       : null,
                ptipo               : 2,
                pfiltroperiodo      : 1,
                pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true),
                pstnota             : 3,
                pqtdregistrosnotasf       : 10,
                ptpdata             : 0, 
                lstnotas            : [],
                pagina_atualnotaf        : 1,
                pqtd_paginasnotaf        : 1,
                pqtd_total_registrosnotasf: 0,
                totalnotas          : 0,
                detnota                 : [],
                lstitensexportar        : [],
                


                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "",
                        name: "situacao",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                    },
                    {
                        label: "Conf.",
                        name: "conferida",
                        sort: true,
                        slot_name: "slot_conferida",
                        row_classes: "def-col-conferida",
                    },                                        
                    {
                        label: "Número",
                        name: "numero",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "slot_numero",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nr. compra",
                        name: "codpedcompra",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Cod. Auxiliar",
                        name: "auxiliar",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "def-col-codaux",
                    },
                    {
                        label: "Efetivação",
                        name: "dtefetivacao",
                        slot_name: "slot_dtefetivacao",
                        initial_sort : false,
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total da Nota",
                        name: "vtotvtotal",
                        sort: true,
                        initial_sort : false,
                        slot_name: "slot_vtotvtotal",
                        row_classes: "def-col-vtotvtotal",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Tipo",
                        name: "tipo",
                        sort: true,
                        slot_name: "slot_tipo",
                        row_classes: "def-col-situacao",
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }

            }
        },
        methods:{
            mtdfiltropesquisa(){
                let rfiltro = '';
                
                rfiltro = this.pnumero === '' ? '' : ' AND n.numero='+this.pnumero;
                
                if (this.pidfornecedor !== null){
                    rfiltro = rfiltro + ' AND n.idfornecedor='+this.pidfornecedor;
                }                
                
                if (this.pidfilial !== null){
                    rfiltro = rfiltro + ' AND n.idfilial='+this.pidfilial;
                }

                if (parseInt(this.ptipo) < 2){
                    rfiltro = rfiltro + ' AND n.tipo='+this.ptipo;
                }

				if(parseInt(this.pfiltroperiodo) === 1){
                    if(parseInt(this.ptpdata)===0){
                        rfiltro = rfiltro + ' AND n.dtemissao BETWEEN "' + util.InverterData(this.pdtini) + '" AND "' + util.InverterData(this.pdtfim) + '"';
                    }else{
                        rfiltro = rfiltro + ' AND n.dtefetivacao BETWEEN "' + util.InverterData(this.pdtini) + ' 00:00:00" AND "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                    }
                }				                
                
                if (parseInt(this.pstnota) < 3){
                    rfiltro = rfiltro + ' AND n.situacao='+this.pstnota;
                }

                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atualnotaf   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registrosnotasf = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registrosnotasf / vself.pqtdregistrosnotasf);
                    vself.pqtd_paginasnotaf         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarreganotas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarreganotas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistrosnotasf},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistrosnotasf)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
                retorno.then(function (response) {
                    vself.lstnotas   = response.data.notas;
                    vself.totalnotas = response.data.totalnotas;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstnotas = [];
                    vself.totalnotas = 0;
                    loader.hide();
                });
            },
            mtdlimpar_listagem() {
                this.lstnotas = [];
                this.pagina_atualnotaf = 1;
                this.filtro = '';
                this.pqtd_total_registrosnotasf = 0;
                this.pqtd_paginasnotaf = 0;
            },
            mtddetalhesnota(nota){
                let vself = this;
                vself.lstitensexportar  = [];
                vself.detnota           = nota;

                vself.mtdpegarformula(vself.detnota.idfilial);// pega formula


                setTimeout(() => {
                    for (let index = 0; index < vself.detnota.itens.length; index++) {
                        let totalcustoitem = util.calculacustoproduto(vself, 
                            parseFloat(vself.detnota.itens[index].vpipi)/100,
                            parseFloat(vself.detnota.itens[index].vpicms)/100,
                            parseFloat(vself.detnota.itens[index].vpfrete)/100,
                            parseFloat(vself.detnota.itens[index].vvicmsst),//verificar depois o calculo da substituição tributária
                            parseFloat(vself.detnota.itens[index].vppis/100),
                            parseFloat(vself.detnota.itens[index].vpcofins/100),
                            parseFloat(vself.detnota.itens[index].vpoutros/100),
                            parseFloat(vself.detnota.itens[index].prcompra) - parseFloat(vself.detnota.itens[index].vdesconto),
                            parseFloat(vself.detnota.itens[index].vprvendamedio),
                            vself.vformulacustopro//carregado quando a filial é selecionada
                        );

                        vself.detnota.itens[index].vprcusto = totalcustoitem;                    
                    }

                    $('#mddetalhesnf').modal('show');
                        
                }, 700);

            
            },
            mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },
            mtdselect2_def(){
                 let vself = this;
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';

                $("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
                $("#cbfornecedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesq").val();
                    vself.mtdlimpar_listagem();
                });
            },
            mtdpegarformula(idfilial){
                let vself = this;
                let filtro      = ' and f.codfil='+idfilial;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    //{parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                  
                    vself.vformulacustopro = response.data[0].formulacustoproduto;
                }).catch(function (response) {
                   
                });
            },
            mtdimportaprodutos(lstprodutos){
                let lstidprodutos = [];

                if(!lstprodutos){
                    this.$toastr.w('Não há produtos vinculados a essa nota', 'Informação!');
                    return;
                }else{
                    lstidprodutos = lstprodutos.map(idproduto => `'${idproduto.idproduto}'`).join(',');
                    this.$emit('mtdimportaprodutos', lstidprodutos);
                    $('#mdlconsultaprodutosnotafor').modal('hide');
                }
            },
            resetarDados(){
                this.pnumero             = '';
                this.ptipo               = 2;
                this.pfiltroperiodo      = 1;
                this.pstnota             = 3;
                this.pqtdregistrosnotasf   = 10;
                this.pdtini       		 = util.DataAtual(true);
                this.pdtfim       		 = util.DataAtual(true);
                this.pidfilial           = null;
                this.pidfornecedor       = null;

                $('#cbfilialpesq').val(null).trigger('change');
                $('#cbfornecedorpesq').val(null).trigger('change');

            }

        },
        computed:{
            selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },

        },
        watch:{
            pagina_atualnotaf(val){
                this.mtdcarreganotas(val);
            },
        },
        mounted(){
            let vself = this;
             $('#mdlconsultaprodutosnotafor').on('shown.bs.modal', function (e) {
                vself.mtdselect2_def();
                vself.resetarDados();
                vself.mtdlimpar_listagem();
            });
           

        }

    }
</script>
<style>
</style>